export default __webpack_public_path__ + "static/media/hero@2x.27dbb2c3.png";